<template>
    <div class="flex items-center" :class="height">
        <div class="loading loading01 mx-auto text-blue-200 dark:text-slate-500">
            <span :class="textSize">L</span>
            <span :class="textSize">O</span>
            <span :class="textSize">A</span>
            <span :class="textSize">D</span>
            <span :class="textSize">I</span>
            <span :class="textSize">N</span>
            <span :class="textSize">G</span>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
  height: {
      type: String,
      default: () => "min-h-screen",
  },
  textSize: {
    type: String,
    default: ''
  }
})
</script>

<style scoped>
/* common */
.loading {
  font-size: 50px;
  font-family: "Montserrat", sans-serif;
  font-weight: 800;
  text-align: center;
  letter-spacing: 1px;
}
.loading span {
  display: inline-block;
  margin: 0 -0.05em;
}

/* code #1 */
.loading01 span {
  animation: loading01 1.4s infinite alternate;
}
.loading01 span:nth-child(1) {
  animation-delay: 0s;
}
.loading01 span:nth-child(2) {
  animation-delay: 0.1s;
}
.loading01 span:nth-child(3) {
  animation-delay: 0.2s;
}
.loading01 span:nth-child(4) {
  animation-delay: 0.3s;
}
.loading01 span:nth-child(5) {
  animation-delay: 0.4s;
}
.loading01 span:nth-child(6) {
  animation-delay: 0.5s;
}
.loading01 span:nth-child(7) {
  animation-delay: 0.6s;
}

@keyframes loading01 {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
